/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum TagSource {
  Default = 'Default',
  Template = 'Template',
  UserDefined = 'UserDefined',
  Extraction = 'Extraction',
  Classification = 'Classification',
  Recognized = 'Recognized',
  RecognizedMulti = 'RecognizedMulti',
  EInvoiceMulti = 'EInvoiceMulti',
  EInvoice = 'EInvoice',
  DocumentBase = 'DocumentBase',
  EInvoiceValidation = 'EInvoiceValidation'
}
